import { render, staticRenderFns } from "./solutionDatabase.vue?vue&type=template&id=663fc410&"
import script from "./solutionDatabase.vue?vue&type=script&lang=js&"
export * from "./solutionDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports